<template>
  <div class="w-full px-4 mt-5 centrarElemento">
    <div class="mt-10 lg:mt-0">
    <span class="mb-4 block text-lg font-semibold text-primary-500">
        Este es un sitio de pruebas
    </span>
    <h2 class="mb-5 text-3xl font-bold text-neutral-700 sm:text-[40px]/[48px]">
        Aquí se encuentra el listado de tareas asignadas al usuario logueado.
    </h2>
    <p class="mb-5 text-base text-neutral-500">
        Cuando se realice la correcta conexión con el modelo de negocio del sistema y la base de datos, aquí se encontrará la lista de tareas pendientes del empleado, junto con su menú para cambiar el estado de la tarea.
    </p>
    <p class="mb-8 text-base text-neutral-500">
        Este mensaje solo se visualizará en el modelo de ejemplo del sitio.
    </p>
</div>

            </div>
  <div class="list_wrapper">
    <ul role="list" class="divide-y divide-gray-100">
      <li v-for="tasks in data" :key="tasks.id" class="flex justify-between gap-x-6 py-5">
        <div class="flex min-w-0 gap-x-4">
          <img class="h-12 w-12 flex-none rounded-full bg-gray-50" src="/img/logo.png" alt="" />
          <div class="min-w-0 flex-auto">
            <p class="text-sm font-semibold leading-6 text-gray-900">{{ tasks.title }}</p>
            <a :href="`http://localhost:8080/taskinfo/${tasks.id}`" class="mt-1 text-xs leading-5 text-gray-500">Ver
              detalles</a>
          </div>
        </div>
        <div class="containerInfo">
          <div class="flex h-9 min-w-0 gap-x-4">
            <p class="containerStatus flex text-sm items-center ext-gray-900" :style="getStatusStyle(tasks.status)">{{
            tasks.status }}</p>
<div>
            <Menu as="div" class="relative inline-block text-left">
              <div>
                <MenuButton
                  class="inline-flex w-full justify-center gap-x-1.5 rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50">

                  <ChevronDownIcon class="-mr-1 h-5 w-5 text-gray-400" aria-hidden="true" />
                </MenuButton>
              </div>

              <transition enter-active-class="transition ease-out duration-100"
                enter-from-class="transform opacity-0 scale-95" enter-to-class="transform opacity-100 scale-100"
                leave-active-class="transition ease-in duration-75" leave-from-class="transform opacity-100 scale-100"
                leave-to-class="transform opacity-0 scale-95">
                <MenuItems
                  class="absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                  <div class="py-1">
                    &nbsp; Cambiar Estado
                    <form method="POST" action="#">
                      <MenuItem v-slot="{ active }">
                      <button type="submit"
                        :class="[active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'block w-full px-4 py-2 text-left text-sm']">Pendiente</button>
                      </MenuItem>
                    </form>
                    <form method="POST" action="#">
                      <MenuItem v-slot="{ active }">
                      <button type="submit"
                        :class="[active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'block w-full px-4 py-2 text-left text-sm']">En
                        proceso</button>
                      </MenuItem>
                    </form>
                    <form method="POST" action="#">
                      <MenuItem v-slot="{ active }">
                      <button type="submit"
                        :class="[active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'block w-full px-4 py-2 text-left text-sm']">Completado</button>
                      </MenuItem>
                    </form>
                    <form method="POST" action="#">
                      <MenuItem v-slot="{ active }">
                      <button type="submit"
                        :class="[active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'block w-full px-4 py-2 text-left text-sm']">Bloqueado</button>
                      </MenuItem>
                    </form>
                  </div>
                </MenuItems>
              </transition>
            </Menu>
          </div>
          </div>
        </div>

      </li>
    </ul>
  </div>

</template>
<script setup>
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/vue'
import { ChevronDownIcon } from '@heroicons/vue/20/solid'
</script>
<script>
export default {
  data() {
    return {
      data: '',
      items: [
        { status: 'En proceso' },
        { status: 'Pendiente' },
        { status: 'Completado' },
        { status: 'Bloqueado' }
      ]
    };
  }, methods: {
    getStatusStyle(status) {
      switch (status) {
        case 'En proceso':
          return { backgroundColor: 'yellow' };
        case 'Pendiente':
          return { backgroundColor: 'orange' };
        case 'Completado':
          return { backgroundColor: 'lightgreen' };
        case 'Bloqueado':
          return { backgroundColor: 'red' };
        default:
          return { backgroundColor: 'white' }; // Color por defecto si el estado no coincide con ninguno de los anteriores
      }
    }
  },
  async created() {
    try {
      //El id tiene que cambiar por el guardado en session
      const response = await fetch('http://127.0.0.1:8000/api/users/27/tasks');
      const data = await response.json();
      this.data = data;
      console.log(data);
    } catch (error) {
      console.error('Error al obtener datos:', error);
    }
  }
}
</script>